export default [
  {
    path: 'M128 0C57.301 0 0 57.344 0 128v768c0 70.699 57.344 128 128 128h768c70.699 0 128-57.344 128-128V128c0-70.699-57.344-128-128-128H128z',
    fill: '#0079BF',
  },
  {
    path: 'M597.333 170.667v384A42.667 42.667 0 0 0 640 597.333h213.333A42.667 42.667 0 0 0 896 554.667v-384A42.667 42.667 0 0 0 853.333 128H640a42.667 42.667 0 0 0-42.667 42.667z m-469.333 0v640a42.667 42.667 0 0 0 42.667 42.666H384a42.667 42.667 0 0 0 42.667-42.666v-640A42.667 42.667 0 0 0 384 128H170.667A42.667 42.667 0 0 0 128 170.667z',
    fill: '#FFFFFF',
  },
]
